import React , { Component } from 'react';
import Menu from './menu';
import Footer from './footer';
import './App.css';
import {Container,Row,Col,Label,Collapse} from 'reactstrap';
import office from './img/office.png';
import building from './img/building.png';import mploye from './img/mploye.jpg';
import mploye2 from './img/mploye2.jpg';import mploye3 from './img/mploye3.jpg';
import weare from './img/who-we-are.png';

export default class About extends Component {
  render() {
    return (
      <div>
      <Menu />
      <Container>
        <Row className="judul-about text-left">
          <Col sm="8">
            <h1><b>WHO</b> WE ARE?</h1><br/>
            <div className="line"/>
            <h4>We Give The Best Of<br/>IT Solution</h4>
          </Col>
          <Col sm="4">
            <img src={weare} style={{height:"contain"}}/>
          </Col>
        </Row>
        <Row className="about-we" >          
          <Col sm="4">
            <img src={building}/>
          </Col>
          <Col sm="8">
          Agustian techno adalah perusahaan (masih perencanaan) di bidang Software Development Services dan Software Product. 
          Kami memiliki beragam kemampuan untuk Software Development. Namun kami akan berfokus pada bidang Mobile, Web, dan desktop. 
          Seluruh layanan kami tersebut didukung oleh sistem manajemen sumber daya manusia terbaik di kelasnya dan model engagement yang 
          terintegrasi.<br/>
          Kami sangat menyadari bahwa dunia IT senantiasa berkembang sedemikian cepat, 
          sehingga kami selalu berusaha untuk tetap responsif dan inovatif terhadap teknologi 
          terbaru yang selalu kami terapkan untuk lebih meningkatkan efisiensi, efektifitas 
          dan produktifitas.
          </Col>
        </Row>      
        <Row className="text-about">
          <Col sm="8"  style={{paddingTop:"5%"}}>
          Agustian Techno didirikan pada 2018. Awalnya kami fokus pada pengembangan aplikasi berbasis Web. 
          Ketika kami berkembang menjadi lebih baik selama bertahun-tahun, kami beradaptasi untuk mengakomodasi 
          apa yang dibutuhkan dunia. Mengambil tantangan, kami sekarang mahir dalam berbagai platform, 
          menawarkan solusi lengkap, melayani segala jenis industri. Kami juga membangun produk-produk terkait 
          mobilitas konsumen dan perusahaan kami sendiri.<br/>
          Sejak pertama kali didirikan, Agustian Techno tidak ingin dikenal sebagai penyedia layanan / 
          pemasok barang saja, tetapi lebih dari itu, menjadi mitra bagi pelanggan yang memberikan layanan 
          terintegrasi dan memberikan nilai. Itu membuat Agustian Techno Mandiri mampu mempertahankan 
          kualitas layanan yang konsisten.
          </Col>
          <Col sm="4">
            <img src={office}/>
          </Col>
        </Row>
      </Container>
      <Team/>
      <Footer/>      
      </div>
      );
    }
  }
  class Team extends Component {
    constructor(props) {
      super(props);
      this.toggle1 = this.toggle1.bind(this);
      this.toggle2 = this.toggle2.bind(this);
      this.toggle3 = this.toggle3.bind(this);
      this.state = { collapse: false };
    }
    toggle1() {this.setState({ collapse1: !this.state.collapse1 });}
    toggle2() {this.setState({ collapse2: !this.state.collapse2 });}
    toggle3() {this.setState({ collapse3: !this.state.collapse3 });}
  
    render() {
        return (
            <div>
              <section id="team"><br/>
                <Container>
                   <Row className="text-center">
                       <Col sm="12">
                         <h1>Our Team</h1> <hr className="team"/>    
                       </Col>
                   </Row>
                  <Row className="text-center">
                      <Col xs="4">
                        <Label onClick={this.toggle1} ><img src={mploye2} className="pgw"/><br/>MASK ARYAWAN</Label>
                        <Collapse isOpen={this.state.collapse1}>
                          <br/>biodatanya dia, ada info kontak, hobi, dan data lainnnya.
                          bawahnya juga bla bla bla tentang info yang menarik, biar
                          ga jenuh pembacanya.
                        </Collapse>
                      </Col>
                      <Col xs="4">
                        <Label onClick={this.toggle2} ><img src={mploye} className="pgw"/><br/>NAITSUGA</Label>
                        <Collapse isOpen={this.state.collapse2}>
                          <br/>biodatanya dia, ada info kontak, hobi, dan data lainnnya.
                          bawahnya juga bla bla bla tentang info yang menarik, biar
                          ga jenuh pembacanya.
                        </Collapse>
                      </Col>
                      <Col xs="4">
                        <Label onClick={this.toggle3} ><img src={mploye3} className="pgw"/><br/>VEGA WAY</Label>
                        <Collapse isOpen={this.state.collapse3}>
                          <br/>biodatanya dia, ada info kontak, hobi, dan data lainnnya.
                          bawahnya juga bla bla bla tentang info yang menarik, biar
                          ga jenuh pembacanya.
                        </Collapse>
                      </Col>
                  </Row><br/>
                </Container>
              </section>
            </div>
    );
  }
  }


// WEBPACK FOOTER //
// ./src/about.js